
import './App.less'
import '@/styles/index.less'
import '@/styles/font.less'
import '@/styles/iconfont.css'
import logo from '@/assets/images/logo.png';
import title_icon from '@/assets/images/homePage/title_icon.png'
import coin from '@/assets/images/coin.png'
import shopIcon from "@/assets/images/tabbar/shop.png"
import PcLogo from '@/assets/images/PcLogo.png';

import miningIcon from "@/assets/images/tabbar/mining.png"
import whitepaper from '@/assets/images/whitepaper.png'
import whitepaper_zh from '@/assets/images/whitepaper_zh.png'
import StarAi_Pro from '@/assets/images/StarAi_Pro.png'
import StarAi_Tg from '@/assets/images/StarAi_Tg.png'
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import cardTurntable from '@/assets/images/cards/cardTurntable.png'
import IntroductoryPage from "./pages/introductory/index"

import { useDispatch, useSelector } from 'react-redux';
import Tabbar from "@/layout/Tabbar.tsx"
import AOS from 'aos';
import { login, getUserInfo, getEmoji, getCharactersList, getSetting, getInvitation_code, getRefiningTips } from "./api/url.js";
import { getTwitterCallback, getTwitterRefreshToken } from "./api/h5.js";
import { getGuideTypeList } from "./api/account.js";
import { getShareStatusList } from "./api/account.js";
import 'aos/dist/aos.css'; // You can also use <link> for styles
import { useCallback, useEffect, useRef, useState, useLayoutEffect } from 'react'
import { changeCharacterList, changeInviteData, changeToken, changeUserInfo } from './store/module/tabbar.js'
import UpLevelDialog from './components/UpLevelDialog.js'
import LoadingDialog from './components/LoadingDialog.js'
import CheckIn from "./components/checkin/CheckIn"
import NftMint from "./components/nftMint/NftMint"

import wallet from "./hook/wallet/contentWallet"
import { Address } from '@ton/core';
import { changeSettings, changeTurntableDialog } from './store/module/settins.js'
import music from "../src/assets/mp3/horse.mp3"
import coinsMusic from "../src/assets/mp3/coins.mp3"
import TurntableDrawCardsDialog from './components/TurntableDrawCardsDialog.js'
import { changeCardReport } from './store/module/card.js'
import PromptDialog from './components/PromptDialog.js'

import { isH5Handler } from './store/module/h5.config.js'
import Footer from './layout/Footer.js'
import { GoogleLogin } from './components/common/GoogleLogin.js'
import TwitterLoginButton2 from './components/common/TwitterLogin.js'
import PublicDialog from './components/PublicDialog.js'
import useConnectBscWallet from './h5/config/useConnectBscWallet.js'
import useH5Config from './h5/config/useH5Config.js'
import BscSignDialog from './components/common/BscSignDialog.js'
import { changeBscWalletAddress, changeLoginState } from './store/module/h5Login.js'
import HomePage from './components/HomePage.js'
import CoinProgressBar from './components/CoinProgressBar.js'
import { getDataStatistics } from '@/api/account.js'
import { useAccount, useTransaction } from 'wagmi'
import { useTranslation } from 'react-i18next'
import { Toast } from 'react-vant'
import { changeDataStatistics, changeShareStatusList, changeGuideTypeList } from './store/module/progress.js'
const sleep = (time: number) => new Promise((resolve) => setTimeout(resolve, time));
function App() {
  const { t, i18n } = useTranslation();
  const { isH5 } = useH5Config()
  const { address: account, isConnected } = useAccount();
  // const { account, library, active, activate, chainId, deactivate } = useWeb3React()
  const { connectWalletBtn, authWalletHandle, isShowBscSign, setShowBscSign, disConnectHandle, startSign, bscSwitchChainHandle, bscSwitchChain } = useConnectBscWallet()
  const navigate = useNavigate()
  const audioRef = useRef<any>(null)
  const homePageType = useSelector((state: any) => state.tabbar.homePage)
  const isShowSwitchChain = useSelector((state: any) => state.h5.isShowSwitchChain)
  const { settings, isShowIntroductory, turntableDialog, miningPoolConfig } = useSelector((state: any) => state.settings)
  const coinDomCoordinate = useSelector((state: any) => state.tabbar.coinDomCoordinate)
  const { h5LoginType, bscWalletAddress, loginState } = useSelector((state: any) => state.h5Login)
  const address_params = localStorage.getItem('address_params')
  const boxRef = useRef<any>(null)
  AOS.init();
  const check_in_loading = useSelector((state: any) => state.tasks.check_in_loading)
  const flag = useSelector((state: any) => state.tabbar.value);
  const userInfo = useSelector((state: any) => state.tabbar.userInfo)
  const isPlayBgMusic = useSelector((state: any) => state.settings.settings.music)
  const { pathname } = useLocation();
  const dispatch = useDispatch()
  const getShareStatusListFunc = async () => {
    const { code, data } = await getShareStatusList()
    if (code == '0') {
      let obj: any = {}
      if (Array.isArray(data)) {
        data.forEach((el: any) => {
          obj[el.code] = el.tasks
        })
      }
      console.log("🚀 ~ getShareStatusListFunc ~ obj:", obj)
      dispatch(changeShareStatusList(obj))
    }
  }
  useEffect(() => {
    const dataStatisticsFunc = async () => {
      const dataStatistics = await getDataStatistics()
      if (dataStatistics.code == '0') {
        dispatch(changeDataStatistics(dataStatistics.data))
      }
    }
    dataStatisticsFunc()
    dispatch(isH5Handler())
    try {
      dataStatisticsFunc()
    } catch (e) {
      console.log("🚀 ~ useEffect ~ e:", e)
    }

  }, [])

  const getGuideType = async () => {
    const { code, data } = await getGuideTypeList()
    if (code == 0) {
      let obj: any = {}
      if (Array.isArray(data.tasks)) {
        data.tasks.forEach((el: any) => {
          obj[el.code] = el.status
        });
        dispatch(changeGuideTypeList({ ...data, tasks: obj }))
      } else {
        dispatch(changeGuideTypeList(data))
      }
    }
  }
  const setLanguage = async (lang: string) => {
    window.localStorage.setItem('language', lang)
    i18n.changeLanguage(lang)
  }


  useEffect(() => {
    const resizeChange = () => {
      let toolbarHeight = window.innerHeight;
      document.documentElement.style.setProperty('--toolbar-height', `${toolbarHeight}px`);
    };
    resizeChange()
  }, []);
  const init = async () => {
    let rootDom: any = document.getElementById('root')
    rootDom.style.background = '#071919'

    dispatch(isH5Handler())


    if (localStorage.getItem('token') && localStorage.getItem('address_params') == localStorage.getItem('userId')) {
      dispatch(changeBscWalletAddress(localStorage.getItem('userId')))
      // if (localStorage.getItem('walletConnector') == 'B') {
      //   await activate(binanceConnector)
      // } else {
      //   await activate(injected)
      // }
    }
    if (localStorage.getItem('code')) {
      const { data, code } = await getTwitterCallback(localStorage.getItem('code'), localStorage.getItem('state'))
      if (code == '0') {
        localStorage.setItem('id_token', '')
        localStorage.setItem('jwt_token', data.jwt_token)
        localStorage.setItem('userId', data.user_id)
        localStorage.setItem('access_token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
      } else {
        localStorage.setItem('code', '')
        return
      }
    }
    if (!h5LoginType.NT && !bscWalletAddress && !localStorage.getItem('token') && !localStorage.getItem('code')) {
      localStorage.removeItem('address_params')
      localStorage.removeItem('connectCount')
      localStorage.removeItem('userId')
      localStorage.removeItem('walletConnector')
      disConnectHandle()
      // deactivate()
      // localStorage.clear()
      return
    }
    try {
      await getEmoji()
    } catch (e) {
      console.log(e)
    }
    let params: any = {}
    // const { chatInstance, userId, initData, userName, firstName, lastName } = telegramAPI()
    if (true) {
      params = {
        id: localStorage.getItem("userId") || '',
        invitation_code: window.localStorage.getItem("startapp") || '',
        user_name: localStorage.getItem("userName") || '',
        is_primer: false,
        source: 1,
        avatar_url: localStorage.getItem('accountUrl') || '',
        email: localStorage.getItem("email") || '',
        id_token: localStorage.getItem('id_token') || '',
        oauth_token: localStorage.getItem("oauth_token") || '',
        oauth_token_secret: localStorage.getItem("oauth_token_secret") || '',
        track_id: localStorage.getItem("track_id") || '',
        make_a_check_in_in_starai: localStorage.getItem("make_a_check_in_in_starai") || '',
        access_token: localStorage.getItem('access_token') || '',
        refresh_token: localStorage.getItem('refresh_token') || '',
      }
    }
    try {
      if (!bscWalletAddress) {
        const res = await login(params)
        rootDom.style.background = '#071919'
        if (res.code == 0) {
          localStorage.setItem('token', res.data)
        } else if (res.code == 400) {
          if (localStorage.getItem('jwt_token') && localStorage.getItem('access_token') && localStorage.getItem('refresh_token')) {
            const res = await getTwitterRefreshToken(localStorage.getItem('refresh_token'))
            localStorage.setItem('userid', res.userid)
            localStorage.setItem('jwt_token', res.jwt_token)
            localStorage.setItem('access_token', res.access_token)
            localStorage.setItem('refresh_toke', res.refresh_toke)
            params.userId = res.userid
            params.access_token = res.access_token
            params.refresh_token = res.refresh_toke
            const { code, data } = await login(params)
            if (code == 0) {
              localStorage.setItem('token', data)
            }
          }

        }
      } else {
        rootDom.style.background = '#071919'
      }

      getCharactersLists();

      const UserInfo = await getUserInfo(address_params)
      if (UserInfo.code == "0") {
        dispatch(changeUserInfo(UserInfo.data))
      } else {
        for (let i = 0; i < 3; i++) {
          const UserInfo = await getUserInfo(address_params)
          if (UserInfo.code == "0") {
            dispatch(changeUserInfo(UserInfo.data))
            break
          } else {
            await sleep(1000)
          }
        }
      }
      // changeInviteData
      const resInvite = await getInvitation_code()
      if (resInvite.code == '0') {
        dispatch(changeInviteData(resInvite.data))
        localStorage.setItem('inviteCode', resInvite.data.code || '')
        localStorage.setItem('invitation_msy', resInvite.data.invitation_msy || '')
      } else {
        const resInvite = await getInvitation_code()
        if (resInvite.code == "0") {
          dispatch(changeInviteData(resInvite.data))
          localStorage.setItem('inviteCode', resInvite.data.code || '')
          localStorage.setItem('invitation_msy', resInvite.data.invitation_msy || '')

        }
      }

      const setting = await getSetting(localStorage.getItem("userId") || '')
      if (setting.code == 0) {
        if (!setting.data.lang) {
          setLanguage("en")
        } else {
          setLanguage(setting.data.lang)
        }

        dispatch(changeSettings(setting.data))
      }
      getGuideType()
    } catch (e) {
      rootDom.style.background = '#071919'
      const res = await login(params)
      localStorage.setItem('token', res.data)
      dispatch(changeToken(res.data))
      await login(params)
    }
    dispatch(changeLoginState(false))
    getShareStatusListFunc()
  }

  useLayoutEffect(() => {
    window.addEventListener("touchstart", () => {
      if (audioRef.current) {
        audioRef.current?.play()
      }


    })
    return (
      window.removeEventListener("touchstart", () => {
        if (audioRef.current) {
          audioRef.current.play()
        }

      })
    )
  }, [])

  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      // 页面切换到后台，暂停音频
      if (audioRef.current) {
        audioRef.current?.pause();
      }
    } else {
      // 页面切换到前台，可以选择恢复音频
      if (!isPlayBgMusic) {
        return false
      }
      if (audioRef.current) {
        audioRef.current?.play();
      }
    }
  }, [])



  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // 清理函数
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [])

  useEffect(() => {
    setTimeout(async () => {
      const UserInfo = await getUserInfo(address_params)
      if (UserInfo.code == "0") {
        dispatch(changeUserInfo(UserInfo.data))
      }
    }, 300000)
    init()
  }, [h5LoginType.NT, bscWalletAddress])



  const [characterList, setCharacterList] = useState<any>([])
  const getCharactersLists = async () => {
    try {
      const params = {
        type: 1,
        limit: 10,
        page: 1,
        query: ""
      }
      const { code, data } = await getCharactersList(params)

      if (code == '0' && data && data.list.length) {
        setCharacterList(data.list)
        window.localStorage.setItem("characterList", JSON.stringify(data.list))
        dispatch(changeCharacterList(data.list))
      }

    } catch (e) {
      console.log('获取数字人列表失败', e)
    }
  }
  const { useGetWalletAddress, handleOkexConnectClick } = wallet();
  const address = isH5 ? account : useGetWalletAddress()
  if (address) {
    const address_params: any = isH5 ? address : Address.parse(address ? address : '')
    if (address_params && address_params != 'undefined') {
      localStorage.setItem('address_params', address_params)
    } else {
      localStorage.setItem('address_params', '')
    }
  }

  const isShowTabbar = () => {
    switch (pathname) {
      case '/ranks':
      case "/pk":
      case "/cards":
      case "/agents":
      case "/my-invites":
      case "/tasks":
        return true;
      default:
        return false;
    }
  }

  // ---------------------------金币掉落音效--------------------
  const isSoundPlay = useSelector((state: any) => state.settings.settings.sound)
  const AudioRef = useRef<any>()
  const getCoinAnimation = useCallback((x: any, y: any) => {
    const R = 100; // 扩散半径
    const time = 0.25; //扩散过度时间
    const time2 = 1; // 收集过度时间
    const w = 26; // 金币大小
    const Num = 8 //金币数量

    const screenWidth = window.innerWidth;
    const pcX = screenWidth > 768 ? screenWidth > 1536 ? (screenWidth / 2) - 220 : screenWidth > 1920 ? (screenWidth / 2) - 250 : (screenWidth / 2) - 187.5 : 0
    setlits((x - pcX), y)

    if (AudioRef.current) {
      // AudioRef.current.currentTime = 0;
      AudioRef.current.play()
    }
    const total = document.getElementsByClassName('total_1')[0] // 获取金币最终飞向

    function setlits(X: any, Y: any) {
      var species = document.createElement('div');
      species.className = 'species'
      for (let i = 0; i < Num; i++) {
        var img = document.createElement('img');
        img.className = 'speciesstyle'
        img.style.width = w + 'px',
          img.style.height = w + 'px',
          img.style.left = X + 'px',
          img.style.top = Y + 'px',
          img.style.transform = 'translate(0%, 0%)',
          img.style.transition = `${time}s`
        img.src = coin
        species.appendChild(img);
      }
      boxRef.current.appendChild(species)
      setTimeout(() => {
        clickss(X, Y)
      }, 0)
    }
    // 计算金币扩散范围和坐标
    function clickss(X: number, Y: number) {
      const specielist: any = document.getElementsByClassName('speciesstyle')
      const num = specielist.length
      const center = {
        x: X,
        y: Y
      }
      for (let i = 0; i < num; i++) {
        const xz = center.x + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.sin(2 * Math.PI * i / num)
        const yz = center.y + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.cos(2 * Math.PI * i / num)
        specielist[i].style.transform = `translate(${xz - (X + w / 2)}px, ${yz - (Y + w / 2)}px)`
      }
      setTimeout(() => {
        for (let i = 0; i < num; i++) {
          specielist[i].style.transition = `${time2}s`
          specielist[i].style.transform = `translate(0,0)`
          specielist[i].style.left = Math.floor(total?.getBoundingClientRect().x) - pcX + 'px'
          specielist[i].style.top = Math.floor(total?.getBoundingClientRect().y) + 'px'
        }
        // 结束清除蒙层
        setTimeout(() => {
          remove()
        }, (Number(time2) + 0.5) * 500) //飞行时间结束

      }, (Number(time) + 0.5) * 500) //扩散时间结束
    }
    // 清除dom
    function remove() {
      document.getElementsByClassName('species')[0].remove()
    }
  }, [coinDomCoordinate.x, coinDomCoordinate.y, userInfo, flag])

  const audioDOM = useRef<HTMLAudioElement>(null)

  useEffect(() => {
    if (audioDOM.current) {
      if (settings.music) {
        audioDOM.current.loop = true;
        audioDOM.current.muted = false;
        audioDOM.current.play();
      } else {
        audioDOM.current.pause()
      }
    }
  }, [audioDOM.current, settings]);

  const getTips = useCallback(async () => {
    try {
      const { code, data } = await getRefiningTips()
      if (code == 0 && Array.isArray(data.card_report)) {

        dispatch(changeCardReport(data))
      }
    } catch (error) {
      console.log(error)
    }

  }, [])

  useEffect(() => {
    getTips()
  }, [])
  const [refDom, setRefDom] = useState(false)
  // useEffect(() => {
  //   window.addEventListener('unhandledrejection', (error) => {
  //     const str = error.reason.toString();
  //     if (str.includes("WebAppMethodUnsupported")) {
  //       setRefDom(true)
  //       return false;
  //     }
  //   })
  //   return () => {
  //     window.removeEventListener('unhandledrejection', () => { })
  //   }
  // }, [])


  // useEffect(() => {
  //   if (account && active && localStorage.getItem('connectCount') !== '1') {
  //     authWalletHandle()
  //   }
  // }, [account, library, active])


  const loginContent = () => {
    return (
      <div className=' flex flex-col relative items-center py-10 justify-center'>
        <img className=' absolute w-6 top-4 left-4' src={logo} alt="" />
        <p className=' text-[20px] pb-5 font-semibold text-[#333333 ] leading-6'>{t("h5.j")}</p>
        <GoogleLogin type={1}></GoogleLogin>
        <div className='h-[20px]'></div>
        <TwitterLoginButton2></TwitterLoginButton2>
        <div className='pt-5 flex justify-between gap-1 items-center'>
          <img className="h-[3px]" src={title_icon} alt="" />
          <p className=' text-[20px] font-semibold text-[#333333 ] leading-6'>{t("h5.k")}</p>
          <img className="h-[3px] rotate-180" src={title_icon} alt="" />
        </div>
        {connectWalletBtn()}
      </div>
    )
  }
  // className="md:w-[375px] lg:w-[440px] xl:w-[500px] md:absolute md:left-[50%] md:translate-x-[-50%]"
  return (
    <div>
      <div className='fixed z-[1000000] top-0 left-3'>
      </div>
      <div className=' max-xg:hidden fixed top-[50%] lg:scale-[120%] xl:scale-[140%] translate-y-[-50%] lg:left-[162px] xl:left-[182px] flex flex-col justify-center items-center left-[150px] '>
        <img className=' w-[150px] mb-[30px] h-[150px]' src={PcLogo} alt="" />
        <p className=' text-style-1 text-[48px] leading-[58px] font-bold'>BRING AI TO </p>
        <p className=' text-style-1 text-[48px] leading-[58px] font-bold'>BLOCKCHAIN</p>
      </div>
      
      {
        i18n.language == 'en' ? <div className=' max-xg:hidden fixed top-[50%] lg:scale-[120%] xl:scale-[140%] lg:right-[162px] xl:right-[182px] translate-y-[-50%] right-[102px] '>
          <p className=' text-[30px] leading-[38px] text-[#fff] font-medium'>
            The best <span className='text-style-1 text-[48px] leading-[58px] text-[#fff] font-bold'>AI Agent</span>
          </p>
          <p className='max-md:hidden text-[30px] leading-[38px] text-[#fff] font-medium'>
            platform for transforming
          </p>
          <p className=' text-[30px] leading-[38px] text-[#fff] font-medium'>
            your AI creations into
          </p>
          <p className=' text-[30px] leading-[38px] text-[#fff] font-medium'>
            <span className='text-style-1 text-[48px] leading-[58px] text-[#fff] font-bold'>Blockchain</span>  NFTs and
          </p>
          <p className=' text-[30px] leading-[38px] text-[#fff] font-medium'>
            Tokens
          </p>
        </div> :
          <div className=' max-xg:hidden fixed top-[50%] lg:scale-[120%] xl:scale-[140%] lg:right-[162px] xl:right-[182px] translate-y-[-50%] right-[102px] '>
            <p className=' text-[30px] leading-[38px] text-[#fff] font-medium'>
              帮助您将AI创作转化为
            </p>
            <p className='text-style-1 text-[48px] leading-[58px] text-[#fff] font-bold'>
              区块链资产 <span className='text-[30px] leading-[38px] text-[#fff] font-medium'>的最佳</span>
            </p>
            <p className='text-style-1 text-[48px] leading-[58px] text-[#fff] font-bold'>
              AI Agent <span className='text-[30px] leading-[38px] text-[#fff] font-medium'>平台</span>
            </p>

          </div>
      }

      <div ref={boxRef} className={` ${localStorage.getItem('userId') || isH5 ? '' : ''} App relative h-full`}>
        {
          isShowSwitchChain && bscSwitchChainHandle()
        }
        {
          !isShowTabbar() && <div className='absolute bottom-12 left-[100px] opacity-0 w-10 h-[30px] total_1'></div>
        }

        {/* <div ref={boxRef} className={` App w-full h-full`}> */}
        {/* <audio ref={audioDOM} src={horse}></audio> */}
        <LoadingDialog dialog={check_in_loading.loading} point={check_in_loading.point} setDialog={() => { }} title={t("h5.i")} getCoinAnimation={getCoinAnimation}></LoadingDialog>
        {/* <UpLevelDialog getCoinAnimation={getCoinAnimation}></UpLevelDialog> */}
        {/* <GetMedalDialog></GetMedalDialog> */}

        <Outlet></Outlet>
        {
          isShowTabbar() &&
          <div className='h-[40px] py-[5px] bg-[#071919] max-md:w-[100vw] md:w-[375px] lg:w-[440px] xl:w-[500px] z-[100] md:absolute fixed bottom-[88px] px-4 grid grid-cols-4 gap-2'>
            <div onClick={(event) => {
              event.stopPropagation();
              if (localStorage.getItem('token')) {
                navigate("/shop")
              } else {
                dispatch(changeLoginState(true))
              }
            }}
              className='h-[30px] text-[12px] text-white flex justify-center items-center rounded-[15px] bg-gradient-to-l from-[#218b94] to-[#142240]' style={{ boxShadow: '0px -2px 1px #9CA1FD' }}>
              <img src={shopIcon} className='w-[22px] mt-[7px] mr-[2px] h-[20px]' alt="" />{t("bubble.shop")}</div>
            <CheckIn getCoinAnimation={getCoinAnimation}></CheckIn>
            <NftMint></NftMint>
            <div onClick={() => {
              if (localStorage.getItem('token')) {
                navigate('/mining')
              } else {
                dispatch(changeLoginState(true))
              }
            }} className='h-[30px] text-[12px] text-white flex justify-center items-center rounded-[15px] bg-gradient-to-l from-[#082A4E] to-[#637F00]' style={{ boxShadow: '0px -2px 1px #9CDAFD' }}>
              <img src={miningIcon} className='w-[18px] mr-[4px] h-[17px]' alt="" />{t("bubble.mint")}</div>
          </div>
        }
        {
          isShowTabbar() && flag && pathname != '/ranks' &&
          <div className='fixed w-[100vw] md:w-[375px] lg:w-[440px] xl:w-[500px] z-[99] top-0 left-0 md:left-[50%] md:translate-x-[-50%]'>
            <CoinProgressBar userInfo={userInfo}></CoinProgressBar>
          </div>
        }
        {
          isShowTabbar() && flag && <Tabbar userInfo={userInfo}></Tabbar>
        }
        <>
          {/* {isShowTabbar() && <CheckIn getCoinAnimation={getCoinAnimation}></CheckIn>} */}
          {/* {isShowTabbar() && <NftMint></NftMint>} */}
          {/* {isShowTabbar() &&
                <div className=' button-content w-[52px] h-[52px] flex justify-center items-center z-[99] overflow-hidden top-[180px] left-4 absolute'>
                  <img
                    onClick={() => {
                      navigate('/mining')
                    }}
                    className=' w-[52px] relative z-[2] h-[52px]'
                    src={mining} />
                  <div className={`${miningPoolConfig?.standard_remaining == 0 && miningPoolConfig?.vip_remaining == 0 ? 'hidden' : ''} w-3 h-3 bg-[red] rounded-full z-[3] absolute right-0 top-[2px]`}></div>
                </div>
              } */}

          {
            isShowTabbar() &&
            <img
              onClick={() => {
                window.open(isH5 ? 'https://t.me/TheStarAIBot/StarAI' : ' https://app.starai.pro', '_blank');
              }}
              className='flex cursor-pointer justify-center items-center overflow-hidden bottom-[203px] max-md:fixed left-4 w-[52px] absolute z-[99] h-[52px]'
              src={isH5 ? StarAi_Tg : StarAi_Pro} />
          }
          {/* {isShowTabbar() &&
            <img
              onClick={async () => {
            await handleOkexConnectClick()
          }}
          className='flex cursor-pointer justify-center items-center overflow-hidden bottom-[270px] left-4 max-md:fixed  w-[52px] absolute z-[99] h-[52px]'
          src={okxImg} />
          } */}
          {
            isShowTabbar() &&
            <img
              onClick={() => {
                window.open('https://starai-1.gitbook.io/starai', '_blank')
              }}
              className='flex cursor-pointer max-md:fixed justify-center items-center overflow-hidden bottom-[136px] left-4 w-[52px]  absolute z-[99] h-[52px]'
              src={whitepaper} />
          }
        </>
        {pathname == '/cards' &&
          <>
            <img src={cardTurntable} onClick={() => { dispatch(changeTurntableDialog(true)) }} className='z-[99] w-[52px] absolute right-4 max-md:fixed  bottom-[136px] animate-rotate' alt="" />
          </>
        }
        <TurntableDrawCardsDialog dialog={turntableDialog} setDialog={() => { dispatch(changeTurntableDialog(false)) }}></TurntableDrawCardsDialog>
      </div >
      <Footer></Footer>
      {
        isShowIntroductory && <IntroductoryPage></IntroductoryPage>
      }

      {isPlayBgMusic && <audio ref={audioRef} src={music} autoPlay loop id="audio"></audio>}
      {
        isSoundPlay && <audio ref={AudioRef} src={coinsMusic} id="audio"></audio>
      }
      <PromptDialog title={t("other.attention")} dialog={refDom} setDialog={setRefDom} callback={() => { setRefDom(false) }} text={'Your Telegram version is too low. Please update it and try again!'}></PromptDialog>

      {
        loginState &&
        <PublicDialog
          closeOnClickOverlay={false}
          overlay={true} width={"280px"}
          isPadding={false} dialog={loginState}
          setDialog={() => { dispatch(changeLoginState(false)) }}
          content={loginContent()}>
        </PublicDialog>
      }
      {
        isShowBscSign && <BscSignDialog callback={async (val) => {
          if (val === 'cancel') {
            setShowBscSign(false)
            disConnectHandle()
          } else {
            await startSign()
          }
        }}></BscSignDialog>
      }
      {homePageType.showHomePage && <HomePage userInfo={userInfo} dialog={homePageType.showHomePage}></HomePage>}
    </div >
  )
}

export default App

